<div class="d-flex align-items-center">
  <fa-icon class="me-4"
           [icon]="['fab', 'apple']"></fa-icon>
  <div class="flex-grow-1 lh-1 text-truncate">
    <h6 class="mb-1">{{ asset()?.name }}</h6>
    <p class="mb-0 lh-1 text-truncate">
      <small class="text-truncate">{{ asset()?.bundleId }}</small>
    </p>
    <p class="mb-0 mt-2 lh-1 d-flex gap-1 flex-wrap">
      @for (family of asset()?.vppAsset?.deviceFamilies; track family) {
        <span class="badge bg-secondary rounded">{{ family }}</span>
      }
    </p>
  </div>
  <label for="appVersionSelect"
         class="me-2"
         i18n>Version: {{ asset()?.version }}</label>
</div>